export enum ModalMutationTypes {
    ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO = 'ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO',
    ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO = 'ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO',
    ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES = 'ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES',
    ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES = 'ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES',
    ACTION_SHOW_MODAL_FILTRO_ESTUDANTE = 'ACTION_SHOW_MODAL_FILTRO_ESTUDANTE',
    ACTION_HIDE_MODAL_FILTRO_ESTUDANTE = 'ACTION_HIDE_MODAL_FILTRO_ESTUDANTE',
    ACTION_SHOW_MODAL_FILTRO_TURMA = 'ACTION_SHOW_MODAL_FILTRO_TURMA',
    ACTION_HIDE_MODAL_FILTRO_TURMA = 'ACTION_HIDE_MODAL_FILTRO_TURMA',
    ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA = 'ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA',
    ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA = 'ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA',
    SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO = 'SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO',
    SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO = 'SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO',
    RESET_PROFESSOR_SELECIONADO_TELA_FILTRO = 'RESET_PROFESSOR_SELECIONADO_TELA_FILTRO',
    SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO = 'SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO',
    SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO = 'SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO',
    SET_TIPOPESQUISA_TELA_FILTRO_FUNCIONARIOS = 'SET_TIPOPESQUISA_TELA_FILTRO_FUNCIONARIOS',
    SET_ROTA_CHAMAR_FILTRO_FUNCIONARIOS = 'SET_ROTA_CHAMAR_FILTRO_FUNCIONARIOS',
    SET_TIPOPESQUISA_TELA_FILTRO_ESTUDANTES = 'SET_TIPOPESQUISA_TELA_FILTRO_ESTUDANTES',
    SET_ROTA_CHAMAR_FILTRO_ESTUDANTES = 'SET_ROTA_CHAMAR_FILTRO_ESTUDANTES',
    SET_TIPOPESQUISA_TELA_FILTRO_TURMAS = 'SET_TIPOPESQUISA_TELA_FILTRO_TURMAS',
    SET_ROTA_CHAMAR_FILTRO_TURMAS = 'SET_ROTA_CHAMAR_FILTRO_TURMAS',
    ACTION_SHOW_MODAL_LEGADO = 'ACTION_SHOW_MODAL_LEGADO',
    ACTION_HIDE_MODAL_LEGADO = 'ACTION_HIDE_MODAL_LEGADO',
}
